import querystring from 'query-string';

interface DiscountKey {
  _id: string;
  first_fixed?: number;
  first_percent?: number;
  free_months?: number;
  noMinimumContractLength?: boolean;
  [key: string]: any;
}

interface Digistore {
  discountKey?: DiscountKey;
  [key: string]: any;
}

interface UTMParams {
  utm_medium?: string;
  utm_campaign?: string;
  utm_source?: string;
  [key: string]: any;
}

export default function getPricingPageUrl(digistore?: Digistore, utm: UTMParams = {}): string {
  try {
    if (digistore && digistore.discountKey && digistore.discountKey._id) {
      return (
        '/#/subscription/pricing?' +
        querystring.stringify({
          a: 1, // to avoid parse error when getting parameters from hash url
          ...digistore.discountKey,
          discountKey: digistore.discountKey._id,
          _id: undefined,
          replaceDiscountKey: 1,
          ...utm
        })
      );
    }

    return (
      '/#/subscription/pricing?' +
      querystring.stringify({
        a: 1, // to avoid parse error when getting parameters from hash url
        ...utm
      })
    );
  } catch (e) {
    console.log(e);

    return '/#/subscription/pricing';
  }
}
